import { CATALOGUE, TOTAL_POINTS, getPlate } from '../data/plates';
import type { ClaimSet, PlayerState, TripState } from './types';

/**
 * Scores are always derived from claims plus the catalogue, never stored.
 *
 * That means rebalancing points retroactively corrects every past trip, and no
 * stored total can drift out of step with the claims that produced it. The one
 * exception is the server-side leaderboard cache, which is recomputed from the
 * authoritative claims on every write.
 */

/** Unknown ids score 0 - a save from a newer catalogue must not break an old client. */
export function scoreOf(plateIds: Iterable<string>): number {
  let total = 0;
  for (const id of plateIds) {
    total += getPlate(id)?.points ?? 0;
  }
  return total;
}

export function scoreOfClaims(claims: ClaimSet): number {
  return scoreOf(Object.keys(claims));
}

export function lifetimeScore(state: PlayerState): number {
  return scoreOfClaims(state.lifetime);
}

export function tripScore(trip: TripState): number {
  return scoreOfClaims(trip.myClaims);
}

export function collectedCount(state: PlayerState): number {
  return Object.keys(state.lifetime).length;
}

export function catalogueSize(): number {
  return CATALOGUE.length;
}

/** 0-1. Completion by points, which weights the rare finds properly. */
export function completionByPoints(state: PlayerState): number {
  if (TOTAL_POINTS === 0) return 0;
  return lifetimeScore(state) / TOTAL_POINTS;
}

/** 0-1. Completion by count, which is the friendlier "42 of 120" number. */
export function completionByCount(state: PlayerState): number {
  if (CATALOGUE.length === 0) return 0;
  return collectedCount(state) / CATALOGUE.length;
}
